import { render } from "./categoryList.vue?vue&type=template&id=12506444"
import script from "./categoryList.vue?vue&type=script&lang=js"
export * from "./categoryList.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brand/categoryList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "12506444"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('12506444', __exports__)) {
    console.log('reload')
    api.reload('12506444', __exports__)
  }
  
  module.hot.accept("./categoryList.vue?vue&type=template&id=12506444", () => {
    console.log('re-render')
    api.rerender('12506444', render)
  })

}


export default __exports__